// Mouse Smooth scroll on homepage
jQuery(document).ready(function($) {
    $(".mouse_scroll").on("click", function(e) {
        e.preventDefault();
        $("html, body").animate({
            scrollTop: $("#section_reservation").offset().top - 100
        }, 800); // Animation fluide en 800ms
    });
});

// Sticky header on scroll
// Le menu (#degrade_header) devient `position: fixed` quand l'utilisateur a
// dépassé sa position d'origine, avec un slide-down animé. On compense la
// place laissée vide en mémorisant la hauteur d'origine du bandeau.
jQuery(document).ready(function ($) {
    var $headerBar = $('#degrade_header');
    if (!$headerBar.length) {
        return;
    }
    var STICKY_MIN_WIDTH = 1120;

    var $outerHeader = $headerBar.closest('header');
    var isHero = $outerHeader.hasClass('header-home');

    function getBarHeight() {
        // Hauteur réelle du bandeau quand il n'est PAS sticky.
        if ($headerBar.hasClass('is-sticky')) {
            // En sticky le padding est réduit : on ne peut pas mesurer ici,
            // on utilise la valeur mémorisée sur l'attribut data.
            return parseInt($headerBar.attr('data-original-height') || '0', 10);
        }
        return $headerBar.outerHeight();
    }

    function getTrigger() {
        // Sticky dès les premiers pixels de scroll (hero ou non).
        return 1;
    }

    var ticking = false;
    function update() {
        if (ticking) {
            return;
        }
        ticking = true;
        window.requestAnimationFrame(function () {
            var isDesktopSticky = window.innerWidth >= STICKY_MIN_WIDTH;
            var scrollY = window.pageYOffset || document.documentElement.scrollTop;
            var trigger = getTrigger();
            var alreadySticky = $headerBar.hasClass('is-sticky');

            if (!isDesktopSticky) {
                if (alreadySticky) {
                    $headerBar.removeClass('is-sticky');
                    $outerHeader
                        .removeClass('is-sticky-host')
                        .css('--crt-header-bar-height', '');
                }
                ticking = false;
                return;
            }

            if (scrollY > trigger) {
                if (!alreadySticky) {
                    var h = $headerBar.outerHeight();
                    $headerBar.attr('data-original-height', h);
                    $outerHeader
                        .css('--crt-header-bar-height', h + 'px')
                        .addClass('is-sticky-host');
                    $headerBar.addClass('is-sticky');
                }
            } else if (alreadySticky) {
                $headerBar.removeClass('is-sticky');
                $outerHeader
                    .removeClass('is-sticky-host')
                    .css('--crt-header-bar-height', '');
            }
            ticking = false;
        });
    }

    $(window).on('scroll', update);
    $(window).on('resize', update);
    update();
});

console.log(typeof jQuery.fn.slick);